module.exports = __webpack_public_path__ + "img/img_17@2x.1165b2a3.png";